(function(){
  /* PERF (mid-range Android). This used to call getBoundingClientRect() on EVERY
     .product-card inside EVERY .ptrack at DOMContentLoaded — on the home page that is
     five rails and several hundred cards, i.e. one big forced layout during the busiest
     moment of the load. Worse, a MutationObserver watched documentElement with
     subtree:true and re-ran the whole sweep 150ms after ANY DOM change, so the checkout
     app, the loyalty widget, the chat bubble and every lazy image kept re-triggering it
     for the lifetime of the page.
     Three things make it nearly free now:
       1. .is-current only exists in a @media(max-width:639px) rule, so on any wider
          screen the whole routine is dead code — bail out immediately.
       2. Only rails that are actually on screen are measured (tracked by an
          IntersectionObserver), instead of all of them.
       3. Rails are registered lazily and the mutation sweep only looks for NEW rails
          (a cheap querySelectorAll('.ptrack')) rather than re-measuring every card. */
  var MQ = window.matchMedia('(max-width:639px)');
  var pending=null, seen=(window.WeakSet?new WeakSet():null), visible=[], io=null;

  function updateTrack(track){
    var cards=track.querySelectorAll('.product-card');
    if(!cards.length)return;
    var r=track.getBoundingClientRect();
    var center=r.left+r.width/2;
    var best=null,bd=Infinity;
    /* All reads first, all writes after — never interleaved, so layout is forced once. */
    cards.forEach(function(c){
      var cr=c.getBoundingClientRect();
      var d=Math.abs(cr.left+cr.width/2-center);
      if(d<bd){bd=d;best=c;}
    });
    cards.forEach(function(c){c.classList.toggle('is-current',c===best);});
  }
  function updateAll(){
    if(!MQ.matches)return;
    for(var i=0;i<visible.length;i++) updateTrack(visible[i]);
  }
  function schedule(){
    if(pending||!MQ.matches)return;
    pending=requestAnimationFrame(function(){pending=null;updateAll();});
  }
  function register(){
    if(!MQ.matches)return;
    var tracks=document.querySelectorAll('.ptrack');
    if(!tracks.length)return;
    if(!io){
      if(!('IntersectionObserver' in window)){
        /* Ancient browser: fall back to measuring everything, once. */
        visible=[].slice.call(tracks);
        schedule();
        return;
      }
      io=new IntersectionObserver(function(entries){
        var changed=false;
        entries.forEach(function(e){
          var at=visible.indexOf(e.target);
          if(e.isIntersecting && at<0){visible.push(e.target);changed=true;}
          else if(!e.isIntersecting && at>=0){visible.splice(at,1);}
        });
        if(changed)schedule();
      },{rootMargin:'200px 0px'});
    }
    tracks.forEach(function(t){
      if(seen){ if(seen.has(t))return; seen.add(t); }
      else if(t.__dhCur)return; else t.__dhCur=1;
      io.observe(t);
    });
  }
  document.addEventListener('scroll',function(e){
    if(e.target&&e.target.classList&&e.target.classList.contains('ptrack')){schedule();}
  },{capture:true,passive:true});
  window.addEventListener('resize',function(){register();schedule();},{passive:true});
  window.addEventListener('pageshow',function(){register();schedule();});
  window.addEventListener('dh:navigate',function(){register();schedule();});
  if(MQ.addEventListener)MQ.addEventListener('change',function(){register();schedule();});
  if('MutationObserver' in window){
    var t=null;
    function containsProductTrack(node){
      return node.nodeType===1 && (node.matches('.ptrack') ||
        (node.firstElementChild && node.querySelector('.ptrack')));
    }
    new MutationObserver(function(records){
      var relevant=records.some(function(record){
        return (record.target.nodeType===1 && record.target.closest('.ptrack')) ||
          Array.prototype.some.call(record.addedNodes,containsProductTrack) ||
          Array.prototype.some.call(record.removedNodes,containsProductTrack);
      });
      if(!relevant)return;
      clearTimeout(t);t=setTimeout(register,400);
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',register);}else{register();}
})();

(function(){
  var INTERVAL=3500,RESUME_AFTER=5000;
  var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(track){
    if(track.dataset.dhAuto)return;
    track.dataset.dhAuto='1';
    var inView=false,pausedUntil=0;
    function cards(){return track.querySelectorAll('.feature-card');}
    function isSlider(){return window.matchMedia('(max-width:767px)').matches;}
    function centerPos(card){
      var cr=card.getBoundingClientRect(),tr=track.getBoundingClientRect();
      return track.scrollLeft+(cr.left-tr.left)-(track.clientWidth-cr.width)/2;
    }
    function nearestIndex(){
      var c=cards(),center=track.getBoundingClientRect().left+track.clientWidth/2,best=0,bd=Infinity;
      c.forEach(function(el,i){
        var r=el.getBoundingClientRect();
        var d=Math.abs(r.left+r.width/2-center);
        if(d<bd){bd=d;best=i;}
      });
      return best;
    }
    function tick(){
      if(!track.isConnected)return;
      if(!isSlider()||!inView||document.hidden||reducedMotion.matches||track.matches(':focus-within'))return;
      if(Date.now()<pausedUntil)return;
      var c=cards();
      if(c.length<2)return;
      var i=(nearestIndex()+1)%c.length;
      track.scrollTo({left:centerPos(c[i]),behavior:'smooth'});
    }
    ['pointerdown','touchstart','wheel'].forEach(function(ev){
      track.addEventListener(ev,function(){pausedUntil=Date.now()+RESUME_AFTER;},{passive:true});
    });
    /* PERF: the timer itself is now started and stopped by visibility instead of
       ticking forever. tick() was already gated, but an always-running interval still
       wakes the main thread 17x a minute per strip on a phone that is trying to idle. */
    var timer=null;
    function start(){if(!timer&&track.isConnected&&isSlider()&&inView&&!document.hidden&&!reducedMotion.matches&&!track.matches(':focus-within'))timer=setInterval(tick,INTERVAL);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    track.addEventListener('focusin',stop);
    track.addEventListener('focusout',function(){setTimeout(start,0);});
    if(reducedMotion.addEventListener)reducedMotion.addEventListener('change',function(){if(reducedMotion.matches)stop();else start();});
    window.addEventListener('resize',function(){if(isSlider())start();else stop();},{passive:true});
    document.addEventListener('visibilitychange',function(){
      if(document.hidden)stop();else if(inView)start();
    });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){inView=e.isIntersecting;});
        if(inView&&!document.hidden)start();else stop();
      },{threshold:0.4}).observe(track);
    }else{inView=true;start();}
  }
  function init(){document.querySelectorAll('.feature-grid--slider').forEach(setup);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  window.addEventListener('pageshow',init);
  window.addEventListener('dh:navigate',init);
  if('MutationObserver' in window){
    var mt=null;
    function containsFeatureTrack(node){
      return node.nodeType===1 && (node.matches('.feature-grid--slider') ||
        (node.firstElementChild && node.querySelector('.feature-grid--slider')));
    }
    new MutationObserver(function(records){
      var relevant=records.some(function(record){
        return (record.target.nodeType===1 && record.target.closest('.feature-grid--slider')) ||
          Array.prototype.some.call(record.addedNodes,containsFeatureTrack) ||
          Array.prototype.some.call(record.removedNodes,containsFeatureTrack);
      });
      if(!relevant)return;
      clearTimeout(mt);mt=setTimeout(init,400);
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
